/**
 * @deprecated In attesa di ristrutturazione con API v2
 */
export const useVerifyActivationToken = () => {
  // TODO: Implementare con nuovo endpoint
  return {
    data: null,
    isLoading: false,
  };
};
